let htmlHints = {};
const htmlHintsFormatted = {};

function formatHtmlHints() {
  if (htmlHints && htmlHints.length > 0) {
    for (let i = 0; i < htmlHints.length; i += 1) {
      htmlHintsFormatted[htmlHints[i].name] = htmlHints[i].value;
    }
  }
}

if (localStorage.company && localStorage.company !== 'null') {
  htmlHints = JSON.parse(localStorage.company).htmlHints || {};

  formatHtmlHints();
}

const partnerCompanyName = htmlHintsFormatted['webshop.partner.company-name'] || '';
const partnerRegNumber = htmlHintsFormatted['webshop.partner.registration-number'] || '';
const partnerPostalAddress = htmlHintsFormatted['webshop.partner.postall-address'] || '';
const partnerEmailAddress = htmlHintsFormatted['webshop.partner.email-address'] || '';

const country = (localStorage.company && JSON.parse(localStorage.company) && JSON.parse(localStorage.company).address.country) || 'UK';

const data = {
  // FOR UK !
  UK: `
    <div class="content">
        <h4>1. Introduction</h4>
        <ol>
            <li>We are committed to safeguarding the privacy of our website visitors and service users.</li>
            <li>This policy applies where we are acting as a data controller with respect to the personal data of our
                website visitors and service users; in other words, where we determine the purposes and means of the
                processing of that personal data
            </li>
            <li>By using our website and agreeing to this policy, you consent to our use of cookies in accordance with
                the terms of this policy.
            </li>
            <li>In this policy, "we", "us" and "our" refer to ${partnerCompanyName}. For more information about us, see
                Section
                18.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>2. How we use your personal data</h4>
        <ol>
            <li>In this Section 2 we have set out:
                <ul>
                    <li>the general categories of personal data that we may process;</li>
                    <li>the purposes for which we may process personal data; and</li>
                    <li>the legal bases of the processing.</li>
                </ul>
            </li>
            <li>We may process data about your use of our website and services ("usage data"). The usage data may
                include your IP address, geographical location, browser type and version, operating system, referral
                source, length of visit, page views and website
                navigation paths, as well as information about the timing, frequency and pattern of your service use.
                The source of the usage data is our Google Analytics. This usage data may be processed for the purposes
                of analysing the use of the website
                and services. The legal basis for this processing is consent.
            </li>
            <li>We may process your personal data that are provided in the course of the use of our services ("service
                data"). The service data may include your name, email address, telephone number, comments and further
                data you enter. The source of the service
                data is you. The service data may be processed for the purposes of operating our website, providing our
                services, ensuring the security of our website and services, maintaining back-ups of our databases and
                communicating with you. The legal
                basis for this processing is consent and the performance of a contract between you and us and/or taking
                steps, at your request, to enter into such a contract.
            </li>
            <li>We may process information contained in any enquiry you submit to us regarding goods and/or services
                ("enquiry data"). The enquiry data may be processed for the purposes of offering, marketing and selling
                relevant goods and/or services to you.
                The legal basis for this processing is consent.
            </li>
            <li>We may process information that you provide to us for the purpose of subscribing to our email
                notifications and/or newsletters ("notification data"). The notification data may be processed for the
                purposes of sending you the relevant notifications
                and/or newsletters. The legal basis for this processing is consent.
            </li>
            <li>We may process information contained in or relating to any communication that you send to us
                ("correspondence data"). The correspondence data may include the communication content and metadata
                associated with the communication. Our website will
                generate the metadata associated with communications made using the website contact forms. The
                correspondence data may be processed for the purposes of communicating with you and record-keeping.
                The legal basis for this processing is our
                legitimate interests, namely the proper administration of our website and business and communications
                with users.
            </li>
            <li>We may process any of your personal data identified in this policy where necessary for the
                establishment, exercise or defence of legal claims, whether in court proceedings or in an administrative
                or out-of-court procedure. The legal basis for
                this processing is our legitimate interests, namely the protection and assertion of our legal rights,
                your legal rights and the legal rights of others.
            </li>
            <li>We may process any of your personal data identified in this policy where necessary for the purposes of
                obtaining or maintaining insurance coverage, managing risks, or obtaining professional advice. The legal
                basis for this processing is our legitimate
                interests, namely the proper protection of our business against risks.
            </li>
            <li>In addition to the specific purposes for which we may process your personal data set out in this Section
                2, we may also process any of your personal data where such processing is necessary for compliance with
                a legal obligation to which we are
                subject, or in order to protect your vital interests or the vital interests of another natural person.
            </li>
            <li>Please do not supply any other person's personal data to us, unless we prompt you to do so.</li>
        </ol>
    </div>
    <div class="content">
        <h4>3. Automated decision-making</h4>
        <ol>
            <li>We will not use your personal data for the purposes of automated decision-making.</li>
        </ol>
    </div>
    <div class="content">
        <h4>4. Providing your personal data to others</h4>
        <ol>
            <li>We may disclose your personal data to any member of our group of companies (this means our subsidiaries,
                our ultimate holding company and all its subsidiaries) insofar as reasonably necessary for the purposes,
                and on the legal bases, set out in
                this policy.
            </li>
            <li>We may disclose your personal data to our insurers and/or professional advisers insofar as reasonably
                necessary for the purposes of obtaining or maintaining insurance coverage, managing risks, obtaining
                professional advice, or the establishment,
                exercise or defence of legal claims, whether in court proceedings or in an administrative or
                out-of-court procedure.
            </li>
            <li>We may disclose specify personal data category or categories to our suppliers or subcontractors insofar
                as reasonably necessary for developing, maintaining, improving and troubleshooting our services and
                products.
            </li>
            <li>Financial transactions relating to our website and services may be handled by our payment services
                providers. We will share transaction data with our payment services providers only to the extent
                necessary for the purposes of processing your payments,
                refunding such payments and dealing with complaints and queries relating to such payments and refunds.
                You can find information about the payment services providers' privacy policies and practices at
                <a href="https://www.paymentsense.co.uk/legal/privacy/">https://www.paymentsense.co.uk/legal/privacy/</a>
            respective <a href="https://www.telecash.de/datenschutz/">https://www.telecash.de/datenschutz/</a>.
            </li>
            <li>We may disclose your enquiry data to one or more of those selected third party suppliers of goods and
                services identified on our website for the purpose of enabling them to contact you so that they can
                offer, market and sell to you relevant goods
                and/or services. Each such third party will act as a data controller in relation to the enquiry data
                that we supply to it; and upon contacting you, each such third party will supply to you a copy of its
                own privacy policy, which will govern
                that third party's use of your personal data.
            </li>
            <li>In addition to the specific disclosures of personal data set out in this Section 4, we may disclose your
                personal data where such disclosure is necessary for compliance with a legal obligation to which we are
                subject, or in order to protect your
                vital interests or the vital interests of another natural person. We may also disclose your personal
                data where such disclosure is necessary for the establishment, exercise or defence of legal claims,
                whether in court proceedings or in an administrative
                or out-of-court procedure.
            </li>
            <li>We use third-party analytics services to help understand your usage of our services. In particular, we
                provide a limited amount of your information (such as sign-up date and some personal information like
                your email address) to Intercom, Inc. ("Intercom") and utilize Intercom to collect data for analytics
                purposes when you visit our website or use our product. As a data processor acting on our behalf,
                Intercom analyzes your use of our website and/or product and tracks our relationship by way of cookies
                and similar technologies so that we can improve our service to you. For more information on Intercom's
                use of cookies, please visit <a href="https://www.intercom.com/terms-and-policies#cookie-policy">https://www.intercom.com/terms-and-policies#cookie-policy</a>.
                We may also use
                Intercom as a medium for communications, either through email, or through messages within our
                product(s). The Intercom Messenger Apps and Apps in Inbox products may also provide you with access to
                other third party applications such as Stripe. You should consult these third parties' privacy notices
                for further information on their use of your personal data. As part of our service agreements, Intercom
                collects publicly available contact and social information related to you, such as your email address,
                gender, company, job title, photos, website URLs, social network handles and physical addresses, to
                enhance your user experience. For more information on the privacy practices of Intercom, please visit
                <a href="https://www.intercom.com/terms-and-policies#privacy">https://www.intercom.com/terms-and-policies#privacy</a>.
                Intercom's services are governed by Intercom's
                terms of use which can be found at <a href="https://www.intercom.com/terms-and-policies#terms">https://www.intercom.com/terms-and-policies#terms</a>.
                If you would
                like to opt out of having this information collected by or submitted to Intercom, please contact us.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>5. International transfers of your personal data</h4>
        <ol>
            <li>In this Section 5, we provide information about the circumstances in which your personal data may be
                transferred to countries outside the European Economic Area (EEA).
            </li>
            <li>We and our other group companies have offices and facilities in United States and Canada. The European
                Commission has made an "adequacy decision" with respect to the data protection laws of each of these
                countries. Transfers to each of these countries
                will be protected by appropriate safeguards, namely the use of standard data protection clauses adopted
                or approved by the European Commission. The European Commission has made an "adequacy decision" with
                respect to the data protection laws
                of each of these countries.
            </li>
            <li>You acknowledge that personal data that you submit for publication through our website or services may
                be available, via the internet, around the world. We cannot prevent the use (or misuse) of such personal
                data by others.
            </li>
    </div>
    <div class="content">
        <h4>6. Retaining and deleting personal data</h4>
        <ol>
            <li>This Section 6 sets out our data retention policies and procedure, which are designed to help ensure
                that we comply with our legal obligations in relation to the retention and deletion of personal data.
            </li>
            <li>Personal data that we process for any purpose or purposes shall not be kept for longer than is necessary
                for that purpose or those purposes.
            </li>
            <li>We will retain your personal data as follows:
                <ul>
                    <li>personal data category will be retained for a minimum period of 1 day and for a maximum period
                        of 30 days following their submit.
                    </li>
                </ul>
            </li>
            <li>Notwithstanding the other provisions of this Section 6, we may retain your personal data where such
                retention is necessary for compliance with a legal obligation to which we are subject, or in order to
                protect your vital interests or the vital
                interests of another natural person.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>7. Security of personal data</h4>
        <ol>
            <li>We will take appropriate technical and organisational precautions to secure your personal data and to
                prevent the loss, misuse or alteration of your personal data.
            </li>
            <li>We will store all your personal data on secure servers, personal computers and mobile devices, and in
                secure manual record-keeping systems.
            </li>
            <li>Data relating to your enquiries and financial transactions that is sent from your web browser to our web
                server, or from our web server to your web browser, will be protected using encryption technology.
            </li>
            <li>You acknowledge that the transmission of unencrypted (or inadequately encrypted) data over the internet
                is inherently insecure, and we cannot guarantee the security of data sent over the internet.
            </li>
            <li>You should ensure that your password is not susceptible to being guessed, whether by a person or a
                computer program. You are responsible for keeping the password you use for accessing our website
                confidential and we will not ask you for your password
                (except when you log in to our website).
            </li>
    </div>
    <div class="content">
        <h4>8. Amendments</h4>
        <ol>
            <li>We may update this policy from time to time by publishing a new version on our website.</li>
            <li>You should check this page occasionally to ensure you are happy with any changes to this policy.</li>
            <li>We may notify you of changes to this policy by email.</li>
    </div>
    <div class="content">
        <h4>9. Your rights</h4>
        <ol>
            <li>In this Section 9, we have summarised the rights that you have under data protection law. Some of the
                rights are complex, and not all of the details have been included in our summaries. Accordingly, you
                should read the relevant laws and guidance
                from the regulatory authorities for a full explanation of these rights.
            </li>
            <li>Your principal rights under data protection law are:
                <ul>
                    <li>the right to access;</li>
                    <li>the right to rectification;</li>
                    <li>the right to erasure;</li>
                    <li>the right to restrict processing;</li>
                    <li>the right to object to processing;</li>
                    <li>the right to data portability;</li>
                    <li>the right to complain to a supervisory authority; and</li>
                    <li>the right to withdraw consent.</li>
                </ul>
            </li>
            <li>You have the right to confirmation as to whether or not we process your personal data and, where we do,
                access to the personal data, together with certain additional information. That additional information
                includes details of the purposes of
                the processing, the categories of personal data concerned and the recipients of the personal data.
                Providing the rights and freedoms of others are not affected, we will supply to you a copy of your
                personal data. The first copy will be provided
                free of charge, but additional copies may be subject to a reasonable fee.
            </li>
            <li>You have the right to have any inaccurate personal data about you rectified and, taking into account the
                purposes of the processing, to have any incomplete personal data about you completed.
            </li>
            <li>In some circumstances you have the right to the erasure of your personal data without undue delay. Those
                circumstances include: the personal data are no longer necessary in relation to the purposes for which
                they were collected or otherwise processed;
                you withdraw consent to consent-based processing; you object to the processing under certain rules of
                applicable data protection law; the processing is for direct marketing purposes; and the personal data
                have been unlawfully processed. However,
                there are exclusions of the right to erasure. The general exclusions include where processing is
                necessary: for exercising the right of freedom of expression and information; for compliance with a
                legal obligation; or for the establishment,
                exercise or defence of legal claims.
            </li>
            <li>In some circumstances you have the right to restrict the processing of your personal data. Those
                circumstances are: you contest the accuracy of the personal data; processing is unlawful but you oppose
                erasure; we no longer need the personal data
                for the purposes of our processing, but you require personal data for the establishment, exercise or
                defence of legal claims; and you have objected to processing, pending the verification of that
                objection. Where processing has been restricted
                on this basis, we may continue to store your personal data. However, we will only otherwise process it:
                with your consent; for the establishment, exercise or defence of legal claims; for the protection of the
                rights of another natural or legal
                person; or for reasons of important public interest.
            </li>
            <li>You have the right to object to our processing of your personal data on grounds relating to your
                particular situation, but only to the extent that the legal basis for the processing is that the
                processing is necessary for: the performance of a
                task carried out in the public interest or in the exercise of any official authority vested in us; or
                the purposes of the legitimate interests pursued by us or by a third party. If you make such an
                objection, we will cease to process the personal
                information unless we can demonstrate compelling legitimate grounds for the processing which override
                your interests, rights and freedoms, or the processing is for the establishment, exercise or defence of
                legal claims.
            </li>
            <li>You have the right to object to our processing of your personal data for direct marketing purposes
                (including profiling for direct marketing purposes). If you make such an objection, we will cease to
                process your personal data for this purpose.
            </li>
            <li>You have the right to object to our processing of your personal data for scientific or historical
                research purposes or statistical purposes on grounds relating to your particular situation, unless the
                processing is necessary for the performance
                of a task carried out for reasons of public interest.
            </li>
            <li>To the extent that the legal basis for our processing of your personal data is:
                <ul>
                    <li>consent; or</li>
                    <li>that the processing is necessary for the performance of a contract to which you are party or in
                        order to take steps at your request prior to entering into a contract,
                    </li>
                </ul>
                and such processing is carried out by automated means, you have the right to receive your personal data
                from us in a structured, commonly used and machine-readable format. However, this right does not apply
                where it would adversely affect the rights and
                freedoms of others.
            </li>
            <li>If you consider that our processing of your personal information infringes data protection laws, you
                have a legal right to lodge a complaint with a supervisory authority responsible for data protection.
                You may do so in the EU member state of
                your habitual residence, your place of work or the place of the alleged infringement.
            </li>
            <li>To the extent that the legal basis for our processing of your personal information is consent, you have
                the right to withdraw that consent at any time. Withdrawal will not affect the lawfulness of processing
                before the withdrawal.
            </li>
            <li>You may exercise any of your rights in relation to your personal data by written notice to us.</li>
        </ol>
    </div>
    <div class="content">
        <h4>10. Third party websites</h4>
        <ol>
            <li>Our website includes hyperlinks to, and details of, third party websites.</li>
            <li>We have no control over, and are not responsible for, the privacy policies and practices of third
                parties.
            </li>
            <li></li>
        </ol>
    </div>
    <div class="content">
        <h4>11. Personal data of children</h4>
        <ol>
            <li>Our website and services are targeted at persons over the age of 18.</li>
            <li>If we have reason to believe that we hold personal data of a person under that age in our databases, we
                will delete that personal data.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>12. Updating information</h4>
        <ol>
            <li>Please let us know if the personal information that we hold about you needs to be corrected or
                updated.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>13. Acting as a data processor</h4>
        <ol>
            <li>Insofar as we act as a data processor rather than a data controller, this policy shall not apply. Our
                legal obligations as a data processor are instead set out in the contract between us and the relevant
                data controller.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>14. About cookies</h4>
        <ol>
            <li>A cookie is a file containing an identifier (a string of letters and numbers) that is sent by a web
                server to a web browser and is stored by the browser. The identifier is then sent back to the server
                each time the browser requests a page from
                the server.
            </li>
            <li>Cookies may be either "persistent" cookies or "session" cookies: a persistent cookie will be stored by a
                web browser and will remain valid until its set expiry date, unless deleted by the user before the
                expiry date; a session cookie, on the other
                hand, will expire at the end of the user session, when the web browser is closed.
            </li>
            <li>Cookies do not typically contain any information that personally identifies a user, but personal
                information that we store about you may be linked to the information stored in and obtained from
                cookies.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>15. Cookies that we use</h4>
        <ol>
            <li>We use cookies to personalise your experience. We aim to offer you the best possible experience when
                accessing and navigating through our website and using its features. For example, these cookies let us
                recognize that you have created an account and have logged into that account to access the content.
                They help us recognize how you customized the site.
            </li>
            <li>If you want to restrict or block the cookies that are set by our website, you can do so through your
                browser setting. This might impact or entirely prevent the correct usage of our site.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>16. Cookies used by our service providers</h4>
        <ol>
            <li>Our service providers use cookies and those cookies may be stored on your computer when you visit our
                website.
            </li>
            <li>We use Google Analytics to analyse the use of our website. Google Analytics gathers information about
                website use by means of cookies. The information gathered relating to our website is used to create
                reports about the use of our website. Google's privacy policy is available at:
                <a href="https://www.google.com/policies/privacy/">https://www.google.com/policies/privacy/</a>.
            </li>
            <li>We use services provided by Intercom, please refer to section 4. For more information on Intercom's
                use of cookies, please visit
                <a href="https://www.intercom.com/terms-and-policies#cookie-policy">https://www.intercom.com/terms-and-policies#cookie-policy</a>.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>17. Managing cookies</h4>
        <ol>
            <li>Most browsers allow you to refuse to accept cookies and to delete cookies. The methods for doing so vary
                from browser to browser, and from version to version. You can however obtain up-to-date information
                about blocking and deleting cookies via
                these links:
                <ul>
                    <li>https://support.google.com/chrome/answer/95647?hl=en (Chrome);</li>
                    <li>https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences (Firefox);
                    </li>
                    <li>http://www.opera.com/help/tutorials/security/cookies/ (Opera);</li>
                    <li>https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies
                        (Internet Explorer);
                    </li>
                    <li>https://support.apple.com/kb/PH21411 (Safari); and</li>
                    <li>https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy (Edge).</li>
                </ul>
            </li>
            <li>Blocking all cookies will have a negative impact upon the usability of many websites.</li>
            <li>If you block cookies, you will not be able to use all the features on our website.</li>
        </ol>
    </div>
    <div class="content">
        <h4>18. Our details</h4>
        <li>This website is owned and operated by ${partnerCompanyName}.</li>
        <li>We are registered in England and Wales under registration number ${partnerRegNumber}, and our registered office
            is at
            ${partnerPostalAddress}.
        </li>
        <li>Our principal place of business is at ${partnerPostalAddress}.
        </li>
        <li>You can contact us:
            <ul>
                <li>by post, using the postal address given above;</li>
                <li>by email addressed to: <a href="mailto:${partnerEmailAddress}">${partnerEmailAddress}</a></li>
                <li>by telephone, on the contact number published on our website from time to time; or</li>
                <li>by email, using the email address published on our website from time to time.</li>
            </ul>
        </li>
        </ol>
    </div>
`,
  // FOR AT !
  AT: `
    <div class="content">
        <h4>1. Einführung</h4>
        <ol>
            <li>Wir verpflichten uns, die Privatsphäre unserer Website-Besucher und Service-Benutzer zu schützen.</li>
            <li>Diese Richtlinie gilt, wenn wir als Datenverantwortlicher in Bezug auf die personenbezogenen Daten unserer
                Website-Besucher und Service-Benutzer tätig sind; mit anderen Worten, wo wir die Zwecke und Mittel der
                Verarbeitung dieser personenbezogenen Daten bestimmen
            </li>
            <li>Durch die Nutzung unserer Website und die Zustimmung zu dieser Richtlinie stimmen Sie der Verwendung von
                Cookies zu gemäß den Bedingungen dieser Richtlinie.
            </li>
            <li> In dieser Richtlinie beziehen sich "wir", "uns" und "unser" auf ${partnerCompanyName}. Weitere
                Informationen über uns finden Sie im Abschnitt 18.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>2. Wie wir Ihre persönlichen Daten verwenden</h4>
        <ol>
            <li>In diesem Abschnitt 2 legen wir dar:
                <ul>
                    <li>die allgemeinen Kategorien personenbezogener Daten, die wir verarbeiten dürfen;</li>
                    <li>die Zwecke, für die wir personenbezogene Daten verarbeiten dürfen; und</li>
                    <li>die rechtlichen Grundlagen der Verarbeitung.</li>
                </ul>
            </li>
            <li>Wir können Daten über Ihre Nutzung unserer Website und unserer Dienste ("Nutzungsdaten") verarbeiten. Die
                Nutzungsdaten können beinhalten
                Ihre IP-Adresse, Ihren geografischen Standort, den Browsertyp und die Browserversion, das Betriebssystem und
                die Empfehlung an
                Quelle, Besuchsdauer, Seitenaufrufe und Webseiten Navigationspfade sowie Informationen zu Zeitpunkt,
                Häufigkeit und Muster Ihrer Dienstnutzung.
                Die Quelle der Nutzungsdaten ist Google Analytics. Diese Nutzungsdaten können zu diesen Zwecken verarbeitet
                werden
                der Nutzung der Website zu analysieren und Dienstleistungen. Rechtsgrundlage für diese Verarbeitung ist die
                Zustimmung.
            </li>
            <li>Wir können Ihre personenbezogenen Daten verarbeiten, die im Rahmen der Nutzung unserer Dienste zur Verfügung
                gestellt werden
                ("Servicedaten"). Die Servicedaten können Ihren Namen, Ihre E-Mail-Adresse, Ihre Telefonnummer, Kommentare
                und weitere Informationen enthalten
                Daten, die Sie eingeben. Die Quelle dieser Servicedaten sind sie. Die Servicedaten können zum Zwecke des
                Betriebs unserer Website
                verarbeitet werden, sofern unsere Dienstleistungen, Gewährleistung der Sicherheit unserer Website und
                Dienstleistungen, Sicherung unserer Datenbanken und
                mit dir kommunizieren. Die legale Grundlage für diese Verarbeitung ist die Zustimmung und die Erfüllung
                eines Vertrages zwischen Ihnen und uns
                und/oder das Durchführen von Schritten, auf Ihren Wunsch hin, einen solchen Vertrag abzuschließen.
            </li>
            <li>Wir können Informationen verarbeiten, die in einer von Ihnen an uns gesendeten Anfrage zu Waren und / oder
                Dienstleistungen enthalten sind ("Anfragedaten"). Die Anfragedaten können zum Zwecke des Angebots,
                Marketings und Verkaufs verarbeitet
                werden relevante Waren und / oder Dienstleistungen für Sie. Rechtsgrundlage für diese Verarbeitung ist Ihre
                Zustimmung.
            </li>
            <li>
                Wir können Informationen, die Sie uns zur Verfügung stellen, verarbeiten um unsere E-Mail
                Benachrichtigungen zu abonnieren und / oder Newsletter ("Benachrichtigungsdaten"). Die
                Benachrichtigungsdaten können für verarbeitet werden zum Zwecke der Zusendung der entsprechenden
                Benachrichtigungen und / oder Newsletter. Die Rechtsgrundlage für diese Verarbeitung ist Ihre Zustimmung.
            </li>
            <li>
                Wir können Informationen, die in oder im Zusammenhang mit einer von Ihnen an uns gesendeten Mitteilung
                enthalten sind, verarbeiten ("Korrespondenzdaten"). Die Korrespondenzdaten enthalten den
                Kommunikationsinhalt und die mit der mit der Kommunikation verbundenen Metadaten. Unsere Website wird die
                Kommunikations Metadaten über die Kontaktformulare der Website generieren.
                Die Korrespondenzdaten werden zum Zwecke der Kommunikation mit Ihnen und der Führung von Aufzeichnungen
                verarbeitet. Die Rechtsgrundlage für diese Verarbeitung ist unser berechtigtes Interesse an der
                ordnungsgemäßen Verwaltung unserer Website sowie geschäftlichen Tätigkeit und Kommunikation mit Benutzern.
            </li>
            <li>
                Wir können Ihre personenbezogenen Daten gemäß dieser Richtlinie verarbeiten zur Begründung, Ausübung oder
                Verteidigung von Rechtsansprüchen, sei es in Gerichtsverfahren oder in einem Verwaltungs-
                oder außergerichtlichen Verfahren. Die Rechtsgrundlage für diese Verarbeitung ist unser berechtigtes
                Interesse
                an dem Schutz und die Geltendmachung der gesetzlichen Rechte unserer, Ihrer und Dritter.
            </li>
            <li>Wir können Ihre in dieser Richtlinie angegebenen personenbezogenen Daten zum Zwecke der Erhaltung und
                Aufrechterhaltung von Versicherungsschutz, Risiko Management oder der Einholung von professioneller Beratung
                verarbeiten.
                Die legale Grundlage für diese Verarbeitung ist unser Interesse an den angemessenen Schutz
                unseres Geschäfts vor Risiken.
            </li>
            <li>
                Zusätzlich zu den spezifischen Zwecken, für die wir Ihre in diesem Abschnitt 2 genannten personenbezogenen
                Daten verarbeiten können, können wir Ihre personenbezogenen Daten auch verarbeiten, wenn eine solche
                Verarbeitung zur Erfüllung einer gesetzlichen Verpflichtung der wir unterliegen, oder um Ihre wesentlichen
                Interessen oder die wesentlichen Interessen einer anderen natürlichen Person zu schützen.
            </li>
            <li>Bitte geben Sie keine personenbezogenen Daten einer anderen Person an uns weiter, es sei denn, wir fordern
                Sie dazu auf.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>3. Automatisierte Entscheidungsfindung</h4>
        <ol>
            <li>Wir werden Ihre personenbezogenen Daten nicht zum Zwecke der automatisierten Entscheidungsfindung nutzen.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>4. Weitergabe Ihrer persönlichen Daten an Dritte</h4>
        <ol>
            <li>Wir können Ihre personenbezogenen Daten an jedes Mitglied unserer Unternehmensgruppe (daher an unsere
                Tochterunternehmen, unsere oberste Holdinggesellschaft und alle ihre Tochterunternehmen) weitergeben, soweit
                dies für die in dieser Richtlinie dargelegten Zwecke und auf den rechtlichen Grundlagen dieser Richtlinie
                vernünftigerweise erforderlich und zumutbar ist.
            </li>
            <li>
                Wir können Ihre personenbezogenen Daten an unsere Versicherer und / oder professionellen Berater weitergeben
                soweit dies zum Zwecke des Abschlusses oder der Aufrechterhaltung des Versicherungsschutzes, des
                Risikomanagements, der professionellen Beratung oder der Begründung, Ausübung oder Verteidigung von
                Rechtsansprüchen in Gerichtsverfahren zumutbar ist oder in einem administrativen oder außergerichtlichen
                Verfahren.
            </li>
            <li>Wir können unseren Lieferanten oder Subunternehmern bestimmte Kategorien oder Kategorien personenbezogener
                Daten offenlegen, soweit dies für die Entwicklung, Wartung, Verbesserung und Fehlerbehebung unserer
                Dienstleistungen und Produkte zumutbar ist.
            </li>
            <li>Finanztransaktionen im Zusammenhang mit unserer Website und unseren Dienstleistungen können von unseren
                Zahlungsdienstleistern abgewickelt werden. Wir werden Transaktionsdaten nur in dem Umfang an unsere
                Zahlungsdienstleister weitergeben, der für die Verarbeitung Ihrer Zahlungen, die Rückerstattung solcher
                Zahlungen und die Bearbeitung von Beschwerden und Fragen im Zusammenhang mit solchen Zahlungen und
                Rückerstattungen erforderlich ist. Informationen zu den Datenschutzrichtlinien und -praktiken der
                Zahlungsdienstleister finden Sie unter
                <a href="https://www.paymentsense.co.uk/legal/privacy/">https://www.paymentsense.co.uk/legal/privacy/</a>
                bzw. <a href="https://www.telecash.de/datenschutz/">https://www.telecash.de/datenschutz/</a>.
            </li>
            <li>Wir können Ihre Anfragedaten an einen oder mehrere dieser ausgewählten Drittanbieter von Waren und
                Dienstleistungen weitergeben, die auf unserer Website angegeben sind, damit diese Sie kontaktieren können,
                damit sie Ihnen relevante Waren und / oder Dienstleistungen anbieten, vermarkten und verkaufen können.
                Jeder dieser Dritten fungiert als Datenverantwortlicher in Bezug auf die Anfragedaten, die wir ihm zur
                Verfügung stellen. Wenn Sie kontaktiert werden, wird Ihnen jeder dieser Dritten eine Kopie seiner
                eigenen Datenschutzrichtlinie zur Verfügung stellen, die die Verwendung Ihrer persönlichen Daten durch
                diese Dritten regelt.
            </li>
            <li>Zusätzlich zu den in diesem Abschnitt 4 aufgeführten spezifischen Offenlegungen personenbezogener Daten
                können wir Ihre personenbezogenen Daten offenlegen, wenn eine solche Offenlegung zur Erfüllung einer
                gesetzlichen Verpflichtung, der wir unterliegen, oder zum Schutz Ihrer wesentlichen Interessen oder der
                wesentlichen Interessen einer anderen natürlichen Person. Wir können Ihre
                personenbezogenen Daten auch dann offenlegen, wenn eine solche Offenlegung für die Begründung, Ausübung oder
                Verteidigung von Rechtsansprüchen erforderlich ist, sei es in Gerichtsverfahren oder in einem
                administrativen oder außergerichtlichen Verfahren.
            </li>
            <li>Wir verwenden Analysedienste von Drittanbietern, um Ihre Nutzung unserer Dienste zu verstehen. Insbesondere
                stellen wir Intercom, Inc. ("Intercom") eine begrenzte Menge Ihrer Informationen (wie das Anmeldedatum und
                einige persönliche Informationen wie Ihre E-Mail-Adresse) zur Verfügung und verwenden Intercom, um Daten für
                Analysezwecke zu sammeln, wenn Sie unsere besuchen Website oder verwenden Sie unser Produkt. Als in unserem
                Auftrag handelnder Datenverarbeiter analysiert Intercom Ihre Nutzung unserer Website und / oder unseres
                Produkts und verfolgt unsere Beziehung mithilfe von Cookies und ähnlichen Technologien, damit wir unseren
                Service für Sie verbessern können. Weitere Informationen zur Verwendung von Cookies durch Intercom finden
                Sie unter <a href="https://www.intercom.com/terms-and-policies#cookie-policy">https://www.intercom.com/terms-and-policies#cookie-policy</a>.
                Wir können Intercom auch als Kommunikationsmedium verwenden, entweder per E-Mail oder über Nachrichten
                innerhalb unserer Produkte. Mit den Intercom Messenger-Apps und Apps in Inbox Produkten können Sie
                möglicherweise auch auf andere Anwendungen von Drittanbietern wie Stripe zugreifen. Weitere Informationen
                zur Verwendung Ihrer personenbezogenen Daten finden Sie in den Datenschutzhinweisen dieser Dritten. Im
                Rahmen unserer Servicevereinbarungen sammelt Intercom öffentlich zugängliche Kontakt- und soziale
                Informationen zu Ihnen, wie z. B. Ihre E-Mail-Adresse, Ihr Geschlecht, Ihr Unternehmen, Ihre
                Berufsbezeichnung, Fotos, Website-URLs, Handles für soziale Netzwerke und physische Adressen, um Ihre
                Benutzererfahrung zu verbessern. Weitere Informationen zu den Datenschutzpraktiken von Intercom finden Sie
                unter <a href="https://www.intercom.com/terms-and-policies#privacy">https://www.intercom.com/terms-and-policies#privacy</a>.
                Die Dienste von Intercom unterliegen den Nutzungsbedingungen von Intercom, die unter
                <a href="https://www.intercom.com/terms-and-policies#terms">https://www.intercom.com/terms-and-policies#terms</a>
                zu finden sind.Wenn Sie nicht möchten, dass diese Informationen von Intercom
                gesammelt oder an Intercom übermittelt werden, kontaktieren Sie uns bitte.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>5. Internationale Übermittlung Ihrer persönlichen Daten</h4>
        <ol>
            <li>In diesem Abschnitt 5 informieren wir Sie über die Umstände, unter denen Ihre personenbezogenen Daten in
                Länder außerhalb des Europäischen Wirtschaftsraums (EWR) übertragen werden können.
            </li>
            <li>Wir und unsere anderen Konzernunternehmen haben Büros und Einrichtungen in den USA und Kanada. Die
                Europäische Kommission hat eine "Angemessenheitsentscheidung" in Bezug auf die Datenschutzgesetze jedes
                dieser
                Länder getroffen. Übertragungen in jedes dieser Länder werden durch geeignete Schutzmaßnahmen geschützt,
                nämlich
                durch die Verwendung von Standard-Datenschutzklauseln, die von der Europäischen Kommission angenommen oder
                genehmigt wurden. Die Europäische Kommission hat eine "Angemessenheitsentscheidung" in Bezug auf die
                Datenschutzgesetze jedes dieser Länder getroffen.
            </li>
            <li>Sie erkennen an, dass personenbezogene Daten, die Sie zur Veröffentlichung über unsere Website oder unsere
                Dienste einreichen, möglicherweise über das Internet weltweit verfügbar sind. Wir können die Verwendung
                (oder
                den Missbrauch) solcher personenbezogener Daten durch andere nicht verhindern.
            </li>
    </div>
    <div class="content">
        <h4>6. Speicherung und Löschung personenbezogener Daten</h4>
        <ol>
            <li>In diesem Abschnitt werden unsere Richtlinien und Verfahren zur Vorratsdatenspeicherung aufgeführt, mit
                denen sichergestellt werden soll, dass wir unseren gesetzlichen Verpflichtungen in Bezug auf die
                Vorratsdatenspeicherung und Löschung personenbezogener Daten nachkommen.
            </li>
            <li>Personenbezogene Daten, die wir für einen oder mehrere Zwecke verarbeiten, werden nicht länger aufbewahrt,
                als dies für diesen Zweck oder diese Zwecke erforderlich ist.
            </li>
            <li>Wir werden Ihre persönlichen Daten wie folgt speichern:
                <ul>
                    <li>Die Kategorie der personenbezogenen Daten wird mindestens 1 Tag und höchstens 30 Tage nach ihrer
                        Übermittlung gespeichert.
                    </li>
                </ul>
            </li>
            <li>Ungeachtet der anderen Bestimmungen dieses Abschnitts können wir Ihre personenbezogenen Daten
                aufbewahren, wenn eine solche Aufbewahrung erforderlich ist um einer gesetzlichen Verpflichtung, der wir
                unterliegen, nachzukommen oder um Ihre wichtigen Interessen oder die wichtigen Interessen einer anderen
                natürlichen Person zu schützen.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>7. Sicherheit personenbezogener Daten</h4>
        <ol>
            <li>Wir treffen geeignete technische und organisatorische Vorkehrungen, um Ihre persönlichen Daten zu
                schützen und den Verlust, den Missbrauch oder die Änderung Ihrer persönlichen Daten zu verhindern.
            </li>
            <li>Wir speichern alle Ihre persönlichen Daten auf sicheren Servern, PCs und Mobilgeräten sowie in sicheren
                manuellen Aufzeichnungssystemen.
            </li>
            <li>Daten zu Ihren Anfragen und Finanztransaktionen, die von Ihrem Webbrowser an unseren Webserver oder von
                unserem Webserver an Ihren Webbrowser gesendet werden, werden mithilfe der Verschlüsselungstechnologie
                geschützt.
            </li>
            <li>Sie erkennen an, dass die Übertragung von unverschlüsselten (oder unzureichend verschlüsselten) Daten
                über das Internet von Natur aus unsicher ist und wir die Sicherheit von Daten, die über das Internet
                gesendet werden, nicht garantieren können.
            </li>
            <li>Sie sollten sicherstellen, dass Ihr Passwort weder von einer Person noch von einem Computerprogramm
                erraten werden kann. Sie sind dafür verantwortlich, das Passwort, dass Sie für den Zugriff auf unsere
                Website verwenden, vertraulich zu behandeln, und wir werden Sie nicht nach Ihrem Passwort fragen
                (außer wenn Sie sich auf unserer Website anmelden).
            </li>
    </div>
    <div class="content">
        <h4>8. Ergänzungen</h4>
        <ol>
            <li>Wir können diese Richtlinie von Zeit zu Zeit aktualisieren, indem wir eine neue Version auf unserer
                Website veröffentlichen.
            </li>
            <li>Sie sollten diese Seite gelegentlich überprüfen, um sicherzustellen, dass Sie mit Änderungen an dieser
                Richtlinie zufrieden sind.
            </li>
            <li>Wir können Sie per E-Mail über Änderungen dieser Richtlinie informieren.</li>
    </div>
    <div class="content">
        <h4>9. Ihre Rechte</h4>
        <ol>
            <li>In diesem Abschnitt haben wir ihre datenschutzrechtlichen Rechte zusammengefasst. Einige dieser Rechte
                sind komplex und nicht alle Details wurden in unsere Zusammenfassungen aufgenommen. Dementsprechend sollten
                Sie die einschlägigen Gesetze und Richtlinien der Regulierungsbehörden lesen, um eine vollständige
                Erläuterung dieser Rechte zu erhalten.
            </li>
            <li>Ihre datenschutzrechtlichen prinzipiellen Rechte sind:
                <ul>
                    <li>das Recht auf Zugang;</li>
                    <li>das Recht auf Berichtigung;</li>
                    <li>das Recht auf Löschung;</li>
                    <li>das Recht, die Verarbeitung einzuschränken;</li>
                    <li>das Recht, der Verarbeitung zu widersprechen;</li>
                    <li>das Recht auf Datenportabilität;</li>
                    <li>das Recht, sich bei einer Aufsichtsbehörde zu beschweren; und</li>
                    <li>das Recht, die Zustimmung zu widerrufen.</li>
                </ul>
            </li>
            <li>Sie haben das Recht zu bestätigen, ob wir Ihre personenbezogenen Daten verarbeiten oder nicht, und, wo
                wir dies tun, auf die personenbezogenen Daten zuzugreifen, zusammen mit bestimmten zusätzlichen
                Informationen. Diese zusätzlichen Informationen enthalten Einzelheiten zu den Zwecken der Verarbeitung, den
                Kategorien der betreffenden personenbezogenen Daten und den Empfängern der personenbezogenen Daten. Sofern
                die Rechte und Freiheiten anderer nicht beeinträchtigt werden, stellen wir Ihnen eine Kopie Ihrer
                persönlichen Daten zur Verfügung. Das erste Exemplar wird kostenlos zur Verfügung gestellt, für zusätzliche
                Exemplare kann jedoch eine angemessene Gebühr erhoben werden.
            </li>
            <li>Sie haben das Recht, ungenaue personenbezogene Daten über Sie korrigieren zu lassen und unter
                Berücksichtigung der Zwecke der Verarbeitung unvollständige personenbezogene Daten über Sie vervollständigen
                zu lassen.
            </li>
            <li>Unter bestimmten Umständen haben Sie das Recht, Ihre persönlichen Daten unverzüglich zu löschen. Zu
                diesen Umständen gehören: die personenbezogenen Daten sind für die Zwecke, für die sie erhoben oder
                anderweitig verarbeitet wurden, nicht mehr erforderlich; sie widerrufen die Einwilligung zur
                einwilligungsbasierten Verarbeitung; sie widersprechen der Verarbeitung nach bestimmten Regeln des
                geltenden Datenschutzrechts; die Verarbeitung erfolgt zu Direktmarketingzwecken; die personenbezogenen Daten
                wurden rechtswidrig verarbeitet. Es gibt jedoch Ausschlüsse vom Recht auf Löschung. Zu den allgemeinen
                Ausschlüssen gehören, wo eine Verarbeitung erforderlich ist: zur Ausübung des Rechts auf freie
                Meinungsäußerung und Information; zur Einhaltung einer gesetzlichen Verpflichtung; oder zur Begründung,
                Ausübung oder Verteidigung von Rechtsansprüchen.
            </li>
            <li>Unter bestimmten Umständen haben sie das Recht, die Verarbeitung Ihrer persönlichen Daten
                einzuschränken. Diese Umstände sind: sie bestreiten die Richtigkeit der personenbezogenen Daten; die
                Verarbeitung ist rechtswidrig, sie lehnen jedoch das Löschen ab; wir benötigen die personenbezogenen Daten
                nicht mehr für die Zwecke unserer Verarbeitung, aber Sie benötigen personenbezogene Daten für die
                Begründung, Ausübung oder Verteidigung von Rechtsansprüchen; und sie haben der Verarbeitung widersprochen,
                bis der Einwand überprüft wurde. Wenn die Verarbeitung auf dieser Grundlage eingeschränkt wurde, können wir
                Ihre persönlichen Daten weiterhin speichern. Wir werden es jedoch nur anderweitig bearbeiten: mit Ihrer
                Zustimmung; zur Begründung, Ausübung oder Verteidigung von Rechtsansprüchen; zum Schutz der Rechte einer
                anderen natürlichen oder juristischen Person; oder aus Gründen des wichtigen öffentlichen Interesses.
            </li>
            <li>Sie haben das Recht, unserere Verarbeitung Ihrer personenbezogenen Daten aus Gründen zu widersprechen,
                die sich auf Ihre besondere Situation beziehen, jedoch nur insoweit, als die Rechtsgrundlage für die
                Verarbeitung darin besteht, dass die Verarbeitung erforderlich ist für: die Erfüllung einer in der
                öffentliches Interesse oder die Ausübung einer uns übertragenen behördlichen Befugnis; oder die Zwecke der
                berechtigten Interessen, die von uns oder von Dritten verfolgt werden. Wenn Sie einen solchen Widerspruch
                einlegen, werden wir die Verarbeitung der personenbezogenen Daten einstellen, es sei denn, wir können
                zwingende berechtigte Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten
                außer Kraft setzen, oder die Verarbeitung dient der Begründung, Ausübung oder Verteidigung von
                Rechtsansprüchen.
            </li>
            <li>Sie haben das Recht, unserere Verarbeitung Ihrer personenbezogenen Daten für Direktmarketingzwecke
                (einschließlich Profilerstellung für Direktmarketingzwecke) zu widersprechen. Wenn Sie einen solchen
                Widerspruch einlegen, werden wir Ihre personenbezogenen Daten zu diesem Zweck nicht mehr verarbeiten.
            </li>
            <li>Sie haben das Recht, der Verarbeitung Ihrer personenbezogenen Daten zu wissenschaftlichen oder
                historischen Forschungszwecken oder zu statistischen Zwecken aus Gründen zu widersprechen, die sich auf Ihre
                besondere Situation beziehen, es sei denn, die Verarbeitung ist für die Erfüllung einer Aufgabe aus Gründen
                des öffentlichen Interesses erforderlich.
            </li>
            <li>Soweit die Rechtsgrundlage für unsere Verarbeitung Ihrer personenbezogenen Daten ist:
                <ul>
                    <li>Zustimmung; oder</li>
                    <li>dass die Verarbeitung für die Erfüllung eines Vertrags erforderlich ist, an dem Sie beteiligt
                        sind, oder um auf Ihren Wunsch vor Abschluss eines Vertrags Schritte zu unternehmen,
                    </li>
                </ul>
                wenn diese Verarbeitung automatisiert erfolgt, haben Sie das Recht, Ihre persönlichen Daten in einem
                strukturierten, allgemein verwendeten und maschinenlesbaren Format von uns zu erhalten. Dieses Recht
                gilt jedoch nicht, wenn es die Rechte und Freiheiten anderer beeinträchtigen würde.
            </li>
            <li>Wenn Sie der Ansicht sind, dass unsere Verarbeitung Ihrer persönlichen Daten gegen Datenschutzgesetze
                verstößt, haben Sie das Recht, eine Beschwerde bei einer für den Datenschutz zuständigen Aufsichtsbehörde
                einzureichen. Sie können dies im EU-Mitgliedstaat Ihres gewöhnlichen Aufenthalts, Ihres Arbeitsplatzes oder
                des Ortes der mutmaßlichen Zuwiderhandlung tun.
            </li>
            <li>Soweit die Rechtsgrundlage für unsere Verarbeitung Ihrer personenbezogenen Daten die Einwilligung ist,
                haben Sie das Recht, diese Einwilligung jederzeit zu widerrufen. Der Widerruf hat keinen Einfluss auf die
                Rechtmäßigkeit der Verarbeitung vor dem Widerruf.
            </li>
            <li>Sie können alle Ihre Rechte in Bezug auf Ihre persönlichen Daten durch schriftliche Mitteilung an uns
                ausüben.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>10. Websites von Drittanbietern</h4>
        <ol>
            <li>Unsere Website enthält Hyperlinks zu und Details zu Websites Dritter.</li>
            <li>Wir haben keine Kontrolle über die Datenschutzrichtlinien und -praktiken Dritter und sind nicht dafür
                verantwortlich.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>11. Personenbezogene Daten von Kindern</h4>
        <ol>
            <li>Unsere Website und Dienstleistungen richten sich an Personen über 18 Jahre.</li>
            <li>Wenn wir Grund zu der Annahme haben, dass wir personenbezogene Daten einer Person unter diesem Alter in
                unseren Datenbanken speichern, werden wir diese personenbezogenen Daten löschen.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>12. Informationen aktualisieren</h4>
        <ol>
            <li>Bitte teilen Sie uns mit, ob die persönlichen Daten, die wir über Sie gespeichert haben, korrigiert oder
                aktualisiert werden müssen.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>13. Als Auftragsverarbeiter fungieren</h4>
        <ol>
            <li>Soweit wir als Datenverarbeiter und nicht als Datenverantwortlicher auftreten, gilt diese Richtlinie
                nicht. Unsere gesetzlichen Verpflichtungen als Datenverarbeiter sind stattdessen im Vertrag zwischen uns und
                dem jeweiligen für die Verarbeitung Verantwortlichen festgelegt.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>14. Über Cookies</h4>
        <ol>
            <li>Ein Cookie ist eine Datei mit einer Kennung (einer Folge von Buchstaben und Zahlen), die von einem Webserver
                an einen Webbrowser gesendet und vom Browser gespeichert wird. Die Kennung wird dann jedes Mal an den Server
                zurückgesendet, wenn der Browser eine Seite vom Server anfordert.
            </li>
            <li>Cookies können entweder "dauerhafte" Cookies oder "Sitzungs"-Cookies sein: ein dauerhaftes Cookie wird von
                einem Webbrowser gespeichert und bleibt bis zu seinem festgelegten Ablaufdatum gültig, sofern es nicht vom
                Benutzer vor dem Ablaufdatum gelöscht wird. Ein Sitzungscookie läuft dagegen am Ende der Benutzersitzung ab,
                wenn der Webbrowser geschlossen wird.
            </li>
            <li>Cookies enthalten normalerweise keine Informationen, die einen Benutzer persönlich identifizieren.
                Persönliche Informationen, die wir über Sie speichern, können jedoch mit den in Cookies gespeicherten und
                von diesen erhaltenen Informationen verknüpft sein.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>15. Von uns genutzte Cookies</h4>
        <ol>
            <li>Wir verwenden Cookies, um Ihre Erfahrung zu personalisieren. Wir möchten Ihnen die bestmögliche Erfahrung
                beim Zugriff auf und beim Navigieren durch unsere Website und bei der Verwendung ihrer Funktionen bieten.
                Mit diesen Cookies können wir beispielsweise erkennen, dass sie ein Konto erstellt und sich bei diesem Konto
                angemeldet haben, um auf den Inhalt zuzugreifen. Sie helfen uns zu erkennen, wie sie die Website angepasst
                haben.
            </li>
            <li>Wenn sie die von unserer Website gesetzten Cookies einschränken oder blockieren möchten, können sie dies
                über Ihre Browsereinstellung tun. Dies kann die korrekte Nutzung unserer Website beeinträchtigen oder ganz
                verhindern.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>16. Von unseren Dienstleistern verwendete Cookies</h4>
        <ol>
            <li>Unsere Dienstleister verwenden Cookies. Diese Cookies werden möglicherweise auf Ihrem Computer gespeichert,
                wenn Sie unsere Website besuchen.
            </li>
            <li>Wir verwenden Google Analytics, um die Nutzung unserer Website zu analysieren. Google Analytics sammelt
                mithilfe von Cookies Informationen zur Nutzung der Website. Die im Zusammenhang mit unserer Website
                gesammelten Informationen werden verwendet, um Berichte über die Nutzung unserer Website zu erstellen. Die
                Datenschutzbestimmungen von Google finden Sie unter:
                <a href="https://www.google.com/policies/privacy/">https://www.google.com/policies/privacy/</a>.
            </li>
            <li>Wir nutzen die von Intercom bereitgestellten Dienste. Weitere Informationen zur Verwendung von Cookies durch
                Intercom finden Sie unter Abschnitt 4
                <a href="https://www.intercom.com/terms-and-policies#cookie-policy">https://www.intercom.com/terms-and-policies#cookie-policy</a>.
            </li>
        </ol>
    </div>
    <div class="content">
        <h4>17. Cookie Verwaltung</h4>
        <ol>
            <li>In den meisten Browsern können Sie die Annahme von Cookies ablehnen und Cookies löschen. Die Methoden
                hierfür variieren von Browser zu Browser und von Version zu Version. Über diese Links erhalten sie jedoch
                aktuelle Informationen zum Blockieren und Löschen von Cookies:
                <ul>
                    <li>https://support.google.com/chrome/answer/95647?hl=de (Chrome);</li>
                    <li>https://support.mozilla.org/de-DE/kb/enable-and-disable-cookies-website-preferences (Firefox);
                    </li>
                    <li>http://www.opera.com/help/tutorials/security/cookies/ (Opera);</li>
                    <li>https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies
                        (Internet Explorer);
                    </li>
                    <li>https://support.apple.com/kb/PH21411 (Safari); und</li>
                    <li>https://privacy.microsoft.com/de-de/windows-10-microsoft-edge-and-privacy (Edge).</li>
                </ul>
            </li>
            <li>Das Blockieren aller Cookies wirkt sich negativ auf die Benutzerfreundlichkeit vieler Websites aus.</li>
            <li>Wenn sie Cookies blockieren, können sie nicht alle Funktionen unserer Website nutzen.</li>
        </ol>
    </div>
    <div class="content">
        <h4>18. Unsere Details</h4>
        <li>Diese Website gehört und wird betrieben von ${partnerCompanyName}.</li>
        <li>Wir sind in Österreich unter der Registrierungsnummer ${partnerRegNumber} gemeldet und unsere Anschrift lautet
            ${partnerPostalAddress}.
        </li>
        <li>Unser Hauptgeschäftssitz befindet sich in ${partnerPostalAddress}.
        </li>
        <li>Wir sind erreichbar
            <ul>
                <li>per Post unter Verwendung der oben angegebenen Postanschrift;</li>
                <li>per E-Mail an: <a href="mailto:${partnerEmailAddress}">${partnerEmailAddress}</a></li>
                <li>elefonisch unter der von Zeit zu Zeit auf unserer Website veröffentlichten Kontaktnummer; oder</li>
                <li>per E-Mail unter Verwendung der von Zeit zu Zeit auf unserer Website veröffentlichten E-Mail-Adresse.
                </li>
            </ul>
        </li>
        </ol>
    </div>
`,
};


export default data[country];



// WEBPACK FOOTER //
// ./src/components/terms-and-privacy/privacy.js